(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-product-premium-style"] && !Shopify.designMode) return;
  try {
    
  function insertPalettparadisetProductExcerpt() {
    if (!document.querySelector('.pp-product-premium-style .pp-product-assurance')) {
      return;
    }

    document.querySelectorAll('.collapsible-tab .collapsible-content .pp-scope').forEach((scope) => {
      const tab = scope.closest('.collapsible-tab');

      if (!tab || tab.previousElementSibling?.classList.contains('pp-product-excerpt')) {
        return;
      }

      const paragraphs = Array.from(scope.children).filter((element) => element.tagName === 'P');
      const source = paragraphs.find((paragraph) => paragraph.textContent.trim().length > 80) || paragraphs[0];

      if (!source) {
        return;
      }

      const excerpt = document.createElement('div');
      excerpt.className = 'pp-product-excerpt';
      excerpt.appendChild(source);
      tab.parentElement.insertBefore(excerpt, tab);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertPalettparadisetProductExcerpt);
  } else {
    insertPalettparadisetProductExcerpt();
  }

  document.addEventListener('shopify:section:load', insertPalettparadisetProductExcerpt);

  } catch(e) { console.error(e); }
})();
})();
